export default ['#569B3D', '#ADD995', '#B6C6E4', '#876DB4', '#ED9F9B', '#CCD2DB', '#F1BE83', '#63697B'];
